// Partner information utilities

export const getPartnerInfo = () => {
    const partnerInfoString = sessionStorage.getItem('partner-info') || localStorage.getItem('partner-info');
    if (partnerInfoString && partnerInfoString !== 'undefined' && partnerInfoString !== 'null') {
        try {
            return JSON.parse(partnerInfoString);
        } catch (e) {
            console.error('Error parsing partner info:', e);
            // Clear invalid data
            sessionStorage.removeItem('partner-info');
            localStorage.removeItem('partner-info');
            return null;
        }
    }
    return null;
};

export const setPartnerInfo = (partnerInfo, remember = false) => {
    const partnerInfoString = JSON.stringify(partnerInfo);
    if (remember) {
        localStorage.setItem('partner-info', partnerInfoString);
    } else {
        sessionStorage.setItem('partner-info', partnerInfoString);
    }
};

export const clearPartnerInfo = () => {
    sessionStorage.removeItem('partner-info');
    localStorage.removeItem('partner-info');
};

export const getPartnerId = () => {
    const partnerInfo = getPartnerInfo();
    return partnerInfo?.partnerId || partnerInfo?.id || null;
};

export const getPartnerName = () => {
    const partnerInfo = getPartnerInfo();
    return partnerInfo?.partnerName || partnerInfo?.name || '';
};
